import "core-js/modules/es6.object.define-property";
import _get from "lodash/get";

var _createReducer;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { createReducer } from 'redux-act';
import track from "./track";
import { getSavingsEstimate, getBillData } from "../../selectors";
import { addTempData, createBillsharkAccount } from "../../actions";
export default createReducer((_createReducer = {}, _defineProperty(_createReducer, addTempData, function (_ref, payload) {
  var _ref$identity = _ref.identity,
      identity = _ref$identity === void 0 ? {} : _ref$identity;

  var billData = _get(payload, 'bills');

  if (billData) {
    var trackingState = identity.tracking;

    var _ref2 = billData || {},
        selectedBiller = _ref2.selectedBiller,
        billAmount = _ref2.billAmount,
        isExpectedSavingsStepComplete = _ref2.isExpectedSavingsStepComplete,
        isHowItWorksStepComplete = _ref2.isHowItWorksStepComplete;

    var savingsEstimate = getSavingsEstimate(identity) || {};
    var _savingsEstimate$one_ = savingsEstimate.one_time_fee,
        oneTimeFee = _savingsEstimate$one_ === void 0 ? 0 : _savingsEstimate$one_,
        _savingsEstimate$annu = savingsEstimate.annual_savings,
        annualSavings = _savingsEstimate$annu === void 0 ? 0 : _savingsEstimate$annu,
        _savingsEstimate$annu2 = savingsEstimate.annual_savings_after_fee,
        annualSavingsAfterFee = _savingsEstimate$annu2 === void 0 ? 0 : _savingsEstimate$annu2;
    var trackingData = {
      biller: selectedBiller,
      billAmount: billAmount,
      oneTimeFee: oneTimeFee,
      annualSavings: annualSavings,
      annualSavingsAfterFee: annualSavingsAfterFee
    };

    if (isHowItWorksStepComplete) {
      track('billshark-setup:how-it-works-step:complete', trackingState, trackingData);
    } else if (isExpectedSavingsStepComplete) {
      track('billshark-setup:expected-savings-step:complete', trackingState, trackingData);
    }
  }
}), _defineProperty(_createReducer, createBillsharkAccount.success, function (_ref3, payload, _ref4) {
  var _ref3$identity = _ref3.identity,
      identity = _ref3$identity === void 0 ? {} : _ref3$identity;
  var city = _ref4.city,
      addressState = _ref4.addressState,
      postalCode = _ref4.postalCode;
  var trackingState = identity.tracking;
  var billData = getBillData(identity) || {};
  var selectedBiller = billData.selectedBiller,
      billAmount = billData.billAmount;
  var savingsEstimate = getSavingsEstimate(identity) || {};
  var _savingsEstimate$one_2 = savingsEstimate.one_time_fee,
      oneTimeFee = _savingsEstimate$one_2 === void 0 ? 0 : _savingsEstimate$one_2,
      _savingsEstimate$annu3 = savingsEstimate.annual_savings,
      annualSavings = _savingsEstimate$annu3 === void 0 ? 0 : _savingsEstimate$annu3,
      _savingsEstimate$annu4 = savingsEstimate.annual_savings_after_fee,
      annualSavingsAfterFee = _savingsEstimate$annu4 === void 0 ? 0 : _savingsEstimate$annu4;
  var trackingData = {
    biller: selectedBiller,
    billAmount: billAmount,
    oneTimeFee: oneTimeFee,
    annualSavings: annualSavings,
    annualSavingsAfterFee: annualSavingsAfterFee,
    city: city,
    addressState: addressState,
    postalCode: postalCode
  };
  track('billshark-setup:bill-info-step:complete', trackingState, trackingData);
}), _createReducer));